import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { WorkflowTemplateService } from 'app/services/workflow-template.service';
import { WorkflowWizardService } from 'app/services/workflow-wizard.service';
import { EcoDocsTitleService } from 'app/services/ecodocs-title.service';

@Component({
  selector: 'app-materials',
  templateUrl: './materials.component.html',
  styleUrls: ['./materials.component.scss']
})
export class WFMaterialsComponent implements OnInit {


  constructor( private _route: Router, private _workflowService: WorkflowTemplateService, public workflowWizardService: WorkflowWizardService, private ecoDocsTitleService: EcoDocsTitleService) { 
  }

  ngOnInit() {
    this.ecoDocsTitleService.setTitle( 'Workflow Wizard > Materials', false );

    if (this.workflowWizardService.currentId == 'new' && this.workflowWizardService.currentStepURL != this.workflowWizardService.WIZARD_SECOND_STEP) {
      this._route.navigate([this.workflowWizardService.baseURL + this.workflowWizardService.WIZARD_FIRST_STEP]);
    }
  }


  onSecondStepNextClick() {
    if (this.workflowWizardService.workflowTemplateFormGroup.errors?.execNameVariableRequired ||
      this.workflowWizardService.workflowTemplateFormGroup.errors?.observersRequired) {
      return;
    }

    this.workflowWizardService.currentStepURL = this.workflowWizardService.WIZARD_THIRD_STEP;
    this._route.navigate([`${this.workflowWizardService.baseURL}${this.workflowWizardService.WIZARD_THIRD_STEP}`]);
  }

  back(){      
    if (this.workflowWizardService.workflowTemplateFormGroup.errors?.execNameVariableRequired ||
      this.workflowWizardService.workflowTemplateFormGroup.errors?.observersRequired) {
      return;
    }
      
    this.workflowWizardService.currentStepURL = this.workflowWizardService.WIZARD_FIRST_STEP;
    this._route.navigate([`${this.workflowWizardService.baseURL}${this.workflowWizardService.WIZARD_FIRST_STEP}`]);
  }
}
